(function(angular) {
    'use strict';

    angular.module('app').factory('FacilitySettingsService', [
        '$q',
        'FacilitySettingsRepository',
        FacilitySettingsService
    ]);

    function FacilitySettingsService(
        $q,
        FacilitySettingsRepository
    ) {
        var clinicalSummaryTemplates;
        var settingsPromise;
        var userSetting;
        var harmonyCaresIP;

        return {
            getSettings: getSettings,
            getTemplates: getTemplates,
            getUserSetting: getUserSetting,
            getHarmonyCaresIP : getHarmonyCaresIP
        };

        function getSettings(ignoreCache) {
            if(!ignoreCache && settingsPromise) {
                return settingsPromise.catch(function() {
                    settingsPromise = getSettingsFromServer();
                    return settingsPromise;
                });
            }

            settingsPromise = getSettingsFromServer();
            return settingsPromise;
        }

        function getSettingsFromServer() {
            return FacilitySettingsRepository.getSettings().then(function(data) {
                if(!data) {
                    return $q.reject('Invalid Settings data');
                }
                clinicalSummaryTemplates = data.ClinicalSummaryTemplates;
                userSetting = data.UserSetting;
                harmonyCaresIP = data.HarmonyCaresIntegrationPartner;
                return data;
            });
        }

        function getTemplates() {
            return getSettings().then(function() {
                return clinicalSummaryTemplates;
            });
        }

        function getUserSetting() {
            return getSettings().then(function() {
                return userSetting;
            });
        }

        function getHarmonyCaresIP() {
            return getSettings().then(function() {
                return harmonyCaresIP;
            });
        }
    }
})(window.angular);